/**
 * @generated SignedSource<<18af8b47e3c8b2b6fab07b6d7383b9c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type UrlMappingMatchType = "EXACT" | "PREFIX" | "REGEX" | "HOST_PATH" | "TRANSFORM" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UrlMappingTableDataRow_urlMapping$data = {
  readonly id: string;
  readonly name: string | null;
  readonly active: boolean;
  readonly matchType: UrlMappingMatchType;
  readonly priority: number;
  readonly sourceUrl: string | null;
  readonly sourceHost: string | null;
  readonly sourcePath: string | null;
  readonly regexPattern: string | null;
  readonly destinationUrl: string;
  readonly conditions: any;
  readonly " $fragmentType": "UrlMappingTableDataRow_urlMapping";
};
export type UrlMappingTableDataRow_urlMapping = UrlMappingTableDataRow_urlMapping$data;
export type UrlMappingTableDataRow_urlMapping$key = {
  readonly " $data"?: UrlMappingTableDataRow_urlMapping$data;
  readonly " $fragmentSpreads": FragmentRefs<"UrlMappingTableDataRow_urlMapping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UrlMappingTableDataRow_urlMapping",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourceHost",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourcePath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "regexPattern",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "destinationUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conditions",
      "storageKey": null
    }
  ],
  "type": "UrlMapping",
  "abstractKey": null
};

(node as any).hash = "9da932328b539d41b91784f242aee042";

export default node;
